
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

export const SUPPORTED_LANGS = ['es', 'ca', 'en'];
export const DEFAULT_LANG = 'es';
export const LANG_STORAGE_KEY = 'nexus_lang';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LANG,
        supportedLngs: SUPPORTED_LANGS,
        nonExplicitSupportedLngs: true,
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: LANG_STORAGE_KEY,
            caches: ['localStorage'],
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

export async function changeLanguage(lang) {
    if (!SUPPORTED_LANGS.includes(lang)) {
        console.warn(`Idioma no soportado: ${lang}. Usando ${DEFAULT_LANG}.`);
        lang = DEFAULT_LANG;
    }
    await i18n.changeLanguage(lang);
    localStorage.setItem(LANG_STORAGE_KEY, lang);
    if (document?.documentElement) {
        document.documentElement.lang = lang;
    }
}

export function getCurrentLanguage() {
    const lang = i18n.language || localStorage.getItem(LANG_STORAGE_KEY) || DEFAULT_LANG;
    const short = lang.split('-')[0].toLowerCase();
    return SUPPORTED_LANGS.includes(short) ? short : DEFAULT_LANG;
}

if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = getCurrentLanguage();
}

export default i18n;
